import React from "react";
import "./index.css";
import titleline from "../../assets/images/webp/title_line.webp";


function Index({type = '',text=""}) {

  return (
    <>
      <div className="container-fluid vh-100 p-0">
        <div className="google-signing">
          <div className="row h-100 justify-content-center align-items-center">
            <div className="col-md-3 m-auto google-signing-body d-flex align-items-center ">
  <div className="body-inner-left">
                <div className="body-inner-right p-4 text-center">
                   <div className="position-relative mb-0">
                      {type ==="success" && <h1 className="mb-1">SIGNING <span>IN TO </span> METALORDZ</h1>}
                      {type === "error" && <h1 className="mb-1">Sign-In Failed</h1>}
                      <img src={titleline} alt="" className="w-100 position-absolute start-0" height={1} />
                    </div>
                 
                  <p className="h5 pt-4">{text}</p>
              </div>
              </div>
            </div>
          </div>


        </div>
         
        </div>
    </>
  );
}

export default Index;
